<template>
  <van-popup
    :value="show"
    @close="close"
    @click-close-icon="close"
    position="center"
    class="popup"
  >
    <div class="wrap">
      <van-icon name="cross" color="#CCCCCC" class="icon" @click="close" />
      <div class="title">尊敬的{{ jyCardInfo.card_name }}用户</div>
      <div class="desc">
        已为您发放<span>{{ modalData.elementOneText }}</span>
      </div>
      <div class="benefit-list">
        <div
          class="benefit-item"
          v-for="item in modalData.gealDtoList"
          :key="item.gealShowTitle"
        >
          <div class="benefit-title">{{ item.gealShowTitle }}</div>
          <div class="benefit-desc">{{ item.gealShowExplain }}</div>
        </div>
      </div>
      <div class="gift-wrap">
        <div
          class="gift-item"
          v-for="item in modalData.contentList"
          :key="item.rightContent"
        >
          <img
            class="gift-img"
            src="https://common-h5-dev.xiangshuheika.com/static/upload/202605143968bdd816598.png"
          />
          <span class="brown">{{ item.leftContent }}</span
          ><span class="orange">{{ item.rightContent }}</span>
        </div>
      </div>
      <div class="btn" @click="handleBtnClick">{{ btnText }}</div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useStore } from "@/components/use/base";

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Object,
      default: () => ({}),
    },
    jyCardInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const store = useStore();

    const btnText = computed(() => {
      return store.state.isMiniProgram ? "我知道了" : "去使用";
    });

    const close = () => {
      emit("close", false);
    };

    const handleBtnClick = () => {
      if (store.state.isMiniProgram) {
        close();
        return;
      }
      window.location.href = props.modalData.confirmPageUrl;
      close();
    };

    return {
      close,
      handleBtnClick,
      btnText,
    };
  },
});
</script>

<style lang="less" scoped>
.popup {
  width: 295px;
  background: linear-gradient(180deg, #e1effc 0%, #ffffff 100%);
  border-radius: 8px;
}

.wrap {
  position: relative;
  box-sizing: border-box;
  padding: 32px 16px 24px 16px;

  .icon {
    font-size: 16px;
    font-weight: 600;
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .title {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 20px;
  }

  .desc {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 20px;
    margin-top: 4px;

    span {
      color: #e4681d;
    }
  }

  .benefit-list {
    margin-top: 16px;

    .benefit-item {
      overflow: hidden;

      background: #fff7f2;
      height: 83px;
      border-radius: 8px;
      background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2026051416f5824284ddf.png")
        no-repeat;
      background-size: 100%;
      &:not(:last-child) {
        margin-bottom: 8px;
      }

      .benefit-title {
        font-weight: 600;
        font-size: 20px;
        color: #ed681d;
        line-height: 20px;
        text-align: center;
        margin-top: 18px;
      }

      .benefit-desc {
        margin-top: 7px;
        font-weight: 400;
        font-size: 12px;
        color: #e4681d;
        line-height: 20px;
        text-align: center;
      }
    }
  }

  .gift-wrap {
    margin-top: 12px;
    .gift-item {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 12px;
      line-height: 20px;

      .gift-img {
        width: 13px;
        height: 10px;
        margin-right: 6px;
      }

      .brown {
        color: #666666;
      }

      .orange {
        color: #e4681d;
      }
    }
  }

  .btn {
    margin-top: 24px;
    height: 40px;
    background: linear-gradient(90deg, #4082e7 0%, #3254f2 100%), #000000;
    border-radius: 24px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
}
</style>
